import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/core/_config/loader.service';
import { PixResultsService } from './services/pixresults.service';
import { AuthServiceCustom } from 'src/app/core/auth/authServiceCustom';
import { AppConfig } from 'src/app/core/_config/app.config';
import { MatDialog } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { DialogSelectBilletComponent } from './dialog/select-billet/select-billet.component';
import { UpdatePixStatusComponent } from './dialog/update-pix-status/update-pix-status.component';

export enum PixStatusEnum {
    None_All = 0,
    Success = 1,
    Error = 2,
}

@Component({
    selector: 'kt-pix-results',
    templateUrl: './pix-results.component.html',
    styleUrls: ['./pix-results.component.scss'],
})
export class PixResultsComponent implements AfterViewInit, OnInit {
    public dataSource!: any[];
    public filteredData: any[] = []; // lista filtrada

    public pixStatusSelected: number = 0;
    public endDate: Date = new Date();
    public beginDate: Date = new Date();
    public sessionContext: any = {};
    public entityId: string = '';
    public permissionResendPix: boolean = false;
    public searchText: string = '';
    public isNegotiation: boolean = false;
    public PixStatusEnum = PixStatusEnum;
    public titlePage = 'Histórico PIX';
    constructor(
        private pixService: PixResultsService,
        private cdRef: ChangeDetectorRef,
        public _loaderService: LoaderService,
        private authService: AuthServiceCustom,
        private _config: AppConfig,
        private dialog: MatDialog,
        private notification: NotificationsService,
    ) {
        this.sessionContext = JSON.parse(sessionStorage.getItem('ContextSelected') || '{}');
        this.entityId = this.sessionContext?.EntityId || '';
    }
    ngOnInit(): void {
        this.pixService.PermissionResendPix(this.authService.userName).subscribe((data: boolean) => {
            this.permissionResendPix = data;
        });
        this.filteredData = this.dataSource;
    }

    applyFilter() {
        const searchText = this.searchText.toLowerCase();
        this.filteredData = this.dataSource.filter((item) => {
            return Object.values(item).some((val) => val && val.toString().toLowerCase().includes(searchText));
        });
    }

    selectOtherBillets(data: any) {
        let json = JSON.parse(data.json);
        const billetId = data.billetId;

        this._loaderService.show();
        this.pixService.AnotherBillets(billetId, json.Date).subscribe((dataResponse: any) => {
            this._loaderService.hide();

            if (dataResponse) {
                const dialogRef = this.dialog.open(DialogSelectBilletComponent, {
                    data: { dataList: dataResponse, json: json },
                });
                dialogRef.afterClosed().subscribe((result) => {
                    if (result == undefined) {
                        return;
                    }
                    //change PUT
                    this._loaderService.show();
                    let billetsRetryToPay = result.map(function (item: any) {
                        return {
                            billetId: item.billetId,
                            totalToPay: item.billetValue,
                            number: item.number,
                        };
                    });

                    this.pixService.ChangeBilletFromPixResult(data.id, billetsRetryToPay).subscribe(() => {
                        this._loaderService.hide();
                        this.notification.success('Alterado');
                        this.onFilter();
                    });
                });
            } else {
                this.notification.warn('Nenhuma Parcela Encontrada');
            }
        });
    }

    updatePixStatus(data: any) {
        this._loaderService.show();
        const dialogRef = this.dialog.open(UpdatePixStatusComponent, {
            data: { description: data.errorMessage, newPixStatusSelected: data.pixStatus },
        });
        dialogRef.afterClosed().subscribe((result) => {
            this._loaderService.hide();

            if (result == undefined) return;

            this.pixService.UpdatePixStatus(data.id, result.newPixStatusSelected, result.description).subscribe(() => {
                this._loaderService.hide();
                this.notification.success('Alterado');
                this.onFilter();
            });
        });
    }

    ngAfterViewInit() {
        var today = new Date();
        this.endDate = today;

        var lastDay = new Date();
        lastDay.setDate(lastDay.getDate() - 1);

        this.beginDate = lastDay;
        this.LoadSource(PixStatusEnum.None_All, this.beginDate, this.endDate);
    }

    private LoadSource(status: PixStatusEnum, beginDate: Date, endDate: Date) {
        this._loaderService.show();
        if (!this.entityId) return;

        this.pixService
            .GetByFilter(this.entityId, status, beginDate, endDate, this.isNegotiation)
            .subscribe((result: any) => {
                if (result.success) {
                    this.dataSource = result.data;
                    this.filteredData = this.dataSource;
                    this.cdRef.detectChanges();
                }
                this._loaderService.hide();
            });
    }
    public onStatusPixChanged(evt: any) {
        //
    }

    public onFilter() {
        this.LoadSource(this.pixStatusSelected, this.beginDate, this.endDate);
    }

    public gotoAfsBilletId(billetId: string): void {
        this.redirect(`${this._config.urlOldAfs}AccountsReceiving/AccountsReceiving/?BilletId=${billetId}`);
    }

    private redirect(url: string, target = '_blank'): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            try {
                resolve(!!window.open(url, target));
            } catch (e) {
                reject(e);
            }
        });
    }

    public sendAgain(data: any) {
        let json: { username: string; pix: any } = {
            username: this.authService.userName,
            pix: JSON.parse(data.json),
        };

        this._loaderService.show();

        this.pixService
            .ResendPix(json)
            .pipe(
                catchError((error: any) => {
                    this.notification.error(error.error);
                    return throwError('Erro ao Reprocessar PIX');
                }),
            )
            .subscribe(() => {
                this.notification.success('sucesso');
                this.onFilter();
                this._loaderService.hide();
            });
    }

    public getStatusPixDescription(pixStatus: number) {
        if (pixStatus == PixStatusEnum.None_All) return 'Pendente';
        if (pixStatus == PixStatusEnum.Error) return 'Erro';
        if (pixStatus == PixStatusEnum.Success) return 'Recebido';
    }
}
